import { useState } from "react";
import { close, logo, menu } from "../../images/landingPage";
import { navLinks, authLinks } from "../../constants";

const Navbar = ({ onlyAuth }) => {
  const [active, setActive] = useState("hjem");
  const [toggle, setToggle] = useState(false);

  // Function to determine if the link is external
  const isExternalLink = (url) => {
    return /^https?:\/\//.test(url);
  };

  return (
    <nav className="w-full flex py-4 justify-between items-center navbar fixed top-0 left-0 right-0 z-50 bg-black px-6 md:px-12">
      <img
        src={logo}
        alt="Investor Verden Logo"
        className="w-60 h-[60px] object-contain"
      />

      {/* Desktop Navigation */}
      <ul className="list-none sm:flex hidden justify-end items-center space-x-16">
        {!onlyAuth &&
          navLinks.map((nav) => (
            <li
              key={nav.id}
              className={`group font-poppins cursor-pointer text-[16px] ${
                active === nav.id
                  ? "text-secondary font-semibold"
                  : "text-dimWhite font-regular"
              }`}
              onClick={() => setActive(nav.id)}
            >
              {isExternalLink(nav.link) ? (
                <a
                  href={nav.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dimWhite hover:text-secondary"
                >
                  {nav.name}
                </a>
              ) : (
                <a href={nav.link} className="text-dimWhite hover:text-secondary">
                  {nav.name}
                </a>
              )}
              <div className="h-0.5 bg-secondary scale-x-0 group-hover:scale-100 transition-transform origin-left rounded-full duration-300 ease-out" />
            </li>
          ))}

        {authLinks.map((auth) => (
          <li key={auth.id}>
            <a
              href={auth.link}
              className="text-dimWhite hover:text-secondary font-poppins font-medium text-[16px] leading-[24px] cursor-pointer"
            >
              {auth.name}
            </a>
          </li>
        ))}
      </ul>

      {/* Mobile Navigation */}
      <div className="sm:hidden flex flex-1 justify-end items-center">
        <button
          className="relative z-[1000] p-2"
          onClick={() => setToggle(!toggle)}
          aria-label="Toggle navigation menu"
        >
          <img
            src={toggle ? close : menu}
            alt="menu"
            className="w-[28px] h-[28px] object-contain cursor-pointer"
          />
        </button>

        {/* Mobile Menu */}
        <div
          className={`${
            toggle ? "flex" : "hidden"
          } fixed inset-0 bg-black/95 backdrop-blur-md z-[900] flex-col justify-center items-center`}
        >
          <ul className="list-none flex flex-col justify-center items-center w-full h-full space-y-12">
            {!onlyAuth &&
              navLinks.map((nav) => (
                <li
                  key={nav.id}
                  className={`font-poppins font-semibold cursor-pointer text-[24px] ${
                    active === nav.id ? "text-white" : "text-dimWhite"
                  } hover:text-secondary transition-colors duration-300`}
                  onClick={() => {
                    setActive(nav.id);
                    setToggle(false);
                  }}
                >
                  {isExternalLink(nav.link) ? (
                    <a
                      href={nav.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-dimWhite hover:text-secondary"
                    >
                      {nav.name}
                    </a>
                  ) : (
                    <a href={nav.link} className="text-dimWhite hover:text-secondary">
                      {nav.name}
                    </a>
                  )}
                </li>
              ))}

            {authLinks.map((auth) => (
              <li key={auth.id} className="w-full flex justify-center">
                <a
                  href={auth.link}
                  className="text-dimWhite hover:text-secondary font-poppins font-medium text-[24px] leading-[24px] cursor-pointer text-center"
                >
                  {auth.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;